import { useLang } from '../LangContext';
import translations from '../i18n';
import '../climateCrisis.css';

export default function CallForArtists() {
  const { lang } = useLang();
  const t = translations[lang].call;

  return (
    <section id="call" style={{ background: '#ED164E', overflow: 'hidden' }}>

      {/* HERO TITOLO */}
      <div style={{ padding: '80px 40px 60px', borderBottom: '1px solid rgba(255,255,255,0.15)', position: 'relative', overflow: 'hidden', textAlign: 'center' }}>
        <div style={{ position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(8rem, 20vw, 18rem)', color: 'rgba(255,255,255,0.06)', lineHeight: 1, userSelect: 'none', pointerEvents: 'none' }}>2026</div>
        <div className="reveal" style={{ position: 'relative', zIndex: 1 }}>
          {t.sectionLabel && <p style={{ fontFamily: 'var(--font-body)', fontSize: '10px', letterSpacing: '0.4em', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', marginBottom: '20px' }}>{t.sectionLabel}</p>}
          <h2 style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(2.5rem, 7vw, 6rem)', letterSpacing: '0.04em', textTransform: 'uppercase', color: 'var(--white)', lineHeight: 0.95, marginBottom: '16px' }}>{t.title}</h2>
          {t.status && <div style={{ fontFamily: 'var(--font-title-shadow)', fontWeight: 300, fontSize: 'clamp(1.2rem, 3vw, 2.5rem)', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.12em', fontStyle: 'italic' }}>{t.status}</div>}
        </div>
      </div>

      {/* EXTENDED PLAY — lampeggiante */}
      <div style={{ background: 'rgba(0,0,0,0.25)', padding: '20px 40px', borderBottom: '1px solid rgba(255,255,255,0.15)', textAlign: 'center' }}>
        <p style={{
          fontFamily: 'var(--font-title)',
          fontWeight: 600,
          fontSize: 'clamp(1rem, 2vw, 1.4rem)',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'var(--white)',
          animation: 'blink 1.2s ease-in-out infinite',
        }}>
          {t.extendedPlay}
        </p>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)', color: 'rgba(255,255,255,0.9)', marginTop: '6px', letterSpacing: '0.05em' }}>
          {t.extendedDeadline}
        </p>
      </div>

      {/* HEAVY WEATHER */}
      <div className="reveal" style={{ padding: '60px 40px 40px', borderBottom: '1px solid rgba(255,255,255,0.15)', textAlign: 'center' }}>
        <h3 style={{ fontFamily: '"Climate Crisis", var(--font-title)', fontWeight: 400, fontSize: 'clamp(2rem, 5vw, 4.5rem)', color: 'var(--white)', textTransform: 'uppercase', letterSpacing: '0.03em', lineHeight: 1, marginBottom: '40px' }}>{t.heroTitle}</h3>
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          {t.heroText.split('\n\n').map((p, i) => (
            <p key={i} className={`reveal delay-${i + 1}`} style={{ fontFamily: 'var(--font-body)', fontSize: 'clamp(1rem, 1.5vw, 1.15rem)', lineHeight: 1.85, color: 'rgba(255,255,255,0.9)', marginBottom: '20px' }}>{p}</p>
          ))}
        </div>
      </div>

      {/* OPERE COME ATTIVATORI */}
      <div style={{ padding: '40px 40px', borderBottom: '1px solid rgba(255,255,255,0.15)', maxWidth: '860px', margin: '0 auto', textAlign: 'center' }}>
        <h4 className="reveal" style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(1.2rem, 2.5vw, 2rem)', color: 'var(--white)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '24px' }}>{t.subTitle}</h4>
        {t.subText.split('\n\n').map((p, i) => (
          <p key={i} className="reveal" style={{ fontFamily: 'var(--font-body)', fontSize: 'clamp(1rem, 1.5vw, 1.15rem)', lineHeight: 1.85, color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>{p}</p>
        ))}
      </div>

      {/* CHI CERCHIAMO + CATEGORIE + CTA */}
      <div style={{ padding: '40px 40px 60px', textAlign: 'center' }}>
        <h4 className="reveal" style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(1.2rem, 2.5vw, 2rem)', color: 'var(--white)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '16px' }}>{t.whoTitle}</h4>
        <p className="reveal" style={{ fontFamily: 'var(--font-body)', fontSize: '1.05rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.9)', maxWidth: '760px', margin: '0 auto 20px' }}>{t.whoText}</p>
        <div style={{ marginBottom: '40px', display: 'inline-block', textAlign: 'left', maxWidth: '600px', width: '100%' }}>
          {t.whoList.map((item, i) => (
            <div key={i} className={`reveal delay-${i + 1}`} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', marginBottom: '10px' }}>
              <span style={{ fontFamily: 'var(--font-title)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem', flexShrink: 0, marginTop: '2px' }}>→</span>
              <p style={{ fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: '1rem', color: 'var(--white)', lineHeight: 1.5 }}>{item}</p>
            </div>
          ))}
        </div>

        <h4 className="reveal" style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(1.2rem, 2.5vw, 2rem)', color: 'var(--white)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '16px', marginTop: '8px' }}>{t.categoriesTitle}</h4>
        <p className="reveal" style={{ fontFamily: 'var(--font-body)', fontSize: '1.05rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.9)', marginBottom: '20px' }}>{t.categoriesText}</p>
        <div style={{ marginBottom: '40px', display: 'inline-block', textAlign: 'left', maxWidth: '600px', width: '100%' }}>
          {t.categoriesList.map((item, i) => (
            <div key={i} className={`reveal delay-${i + 1}`} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', marginBottom: '8px' }}>
              <span style={{ fontFamily: 'var(--font-body)', color: 'rgba(255,255,255,0.4)', fontSize: '1rem', flexShrink: 0 }}>·</span>
              <p style={{ fontFamily: 'var(--font-body)', fontSize: '1rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.5 }}>{item}</p>
            </div>
          ))}
        </div>

        <p className="reveal" style={{ fontFamily: 'var(--font-body)', fontSize: '0.95rem', lineHeight: 1.7, color: 'rgba(255,255,255,0.7)', maxWidth: '760px', margin: '0 auto 40px' }}>{t.whereText}</p>

        <div className="reveal" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '16px' }}>
          <a href="/regolamento"
            style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '12px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#ED164E', background: 'var(--white)', padding: '16px 36px', transition: 'all 0.3s ease', display: 'inline-block' }}
            onMouseEnter={e => { e.target.style.background = 'var(--black)'; e.target.style.color = 'var(--white)'; }}
            onMouseLeave={e => { e.target.style.background = 'var(--white)'; e.target.style.color = '#ED164E'; }}
          >{t.btnRegolamento}</a>

          <a href={t.formUrl} target="_blank" rel="noopener noreferrer"
            style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '12px', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--white)', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.4)', padding: '16px 36px', transition: 'all 0.3s ease', display: 'inline-block' }}
            onMouseEnter={e => { e.currentTarget.style.background = 'var(--black)'; e.currentTarget.style.borderColor = 'var(--black)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.3)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; }}
          >{t.btnPartecipa} →</a>
        </div>
      </div>

      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.2; }
        }
      `}</style>
    </section>
  );
}
